// extracted by mini-css-extract-plugin
export default {"root":"UOQHtdCvmc_i6mZ3Whji","error":"H6jxoZ4_vMWg9X8FDmcN","placeHolderShimmer":"ogIid6xJdlYcWmCey49R"};